import { useNavigate } from 'react-router-dom';
import { Label } from '@/components/atoms/texts/label';
import { Button } from '@/components/molecules/buttons/button';

const Unauthorized = () => {
    const navigate = useNavigate();

    return (
        <main aria-labelledby="unauthorized-title" className="flex flex-col items-center justify-center gap-6 p-8 min-h-[70vh] text-center">
            <h1 id="unauthorized-title">
                <Label size="h1" fontWeight="bold" message="error.title" />
            </h1>
            <p>
                <Label size="body" message="error.fromServer.forbidden" />
            </p>
            <Button text="navbarGlobal.home" onClick={() => navigate('/')} />
        </main>
    );
};

export default Unauthorized;